module.exports = __webpack_public_path__ + "static/measure-24ed0571fc8d75aa66e9394b58db2dfe.mp4";